import { render, staticRenderFns } from "./ListasPrecioLayout.vue?vue&type=template&id=6e6d7a00&"
import script from "./ListasPrecioLayout.vue?vue&type=script&lang=js&"
export * from "./ListasPrecioLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})
